import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_USER_FORM_REQUEST = `${app.NS}user/save_user_form_request`;
export const SAVE_USER_FORM_REQUEST_ACTION = createAction(
  SAVE_USER_FORM_REQUEST
);
const SAVE_USER_FORM_SUCCESS = `${app.NS}user/save_user_form_success`;
export const SAVE_USER_FORM_SUCCESS_ACTION = createAction(
  SAVE_USER_FORM_SUCCESS
);
const SAVE_USER_FORM_FAILURE = `${app.NS}user/save_user_form_failure`;
export const SAVE_USER_FORM_FAILURE_ACTION = createAction(
  SAVE_USER_FORM_FAILURE
);

export const saveUserFormRequest = id => {
  const action = SAVE_USER_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveUserFormSuccess = user => {
  const action = SAVE_USER_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveUserFormFailure = error => {
  const action = SAVE_USER_FORM_FAILURE_ACTION(error);
  return action;
};

const SAVE_USER_ACCEPT_TERMS_REQUEST = `${
  app.NS
}user/save_user_accept_terms_request`;
export const SAVE_USER_ACCEPT_TERMS_REQUEST_ACTION = createAction(
  SAVE_USER_ACCEPT_TERMS_REQUEST
);
const SAVE_USER_ACCEPT_TERMS_SUCCESS = `${
  app.NS
}user/save_user_accept_terms_success`;
export const SAVE_USER_ACCEPT_TERMS_SUCCESS_ACTION = createAction(
  SAVE_USER_ACCEPT_TERMS_SUCCESS
);
const SAVE_USER_ACCEPT_TERMS_FAILURE = `${
  app.NS
}user/save_user_accept_terms_failure`;
export const SAVE_USER_ACCEPT_TERMS_FAILURE_ACTION = createAction(
  SAVE_USER_ACCEPT_TERMS_FAILURE
);

export const saveUserAcceptTermsRequest = id => {
  const action = SAVE_USER_ACCEPT_TERMS_REQUEST_ACTION(id);
  return action;
};
export const saveUserAcceptTermsSuccess = user => {
  const action = SAVE_USER_ACCEPT_TERMS_SUCCESS_ACTION(user);
  return action;
};

export const saveUserAcceptTermsFailure = error => {
  const action = SAVE_USER_ACCEPT_TERMS_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/user.js